/* global Modernizr */

import { featureDetectionActions } from 'actions';
import { useEffect } from 'react';
import { useRedux } from 'shared/hooks';
import FeatureDetectionModal from './FeatureDetectionModal';

const defaultFeatures = [
  Modernizr.blobconstructor,
  Modernizr.canvas,
  Modernizr.svg,
  Modernizr.todataurljpeg,
  Modernizr.flexbox,
  Modernizr.localstorage,
  Modernizr.atobbtoa,
  Modernizr.websockets,
];

const FeatureDetectionContainer = () => {
  const { setModalState, isModalOpen } = useRedux('featureDetectionReducer', featureDetectionActions);

  useEffect(() => {
    setModalState(defaultFeatures.some((featureTest) => !featureTest));
  }, [setModalState]);

  const handleClose = () => setModalState(false);

  return <FeatureDetectionModal isOpen={isModalOpen} onClose={handleClose} />;
};

export default FeatureDetectionContainer;
